import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { VigenciaTarifa } from '../../../containers'

const VigenciasTarifas = (props) => {
  const { concessionaria } = props
  return (
    <div>
      <Switch>
        <Route
          exact path='/concessionarias/:concessionariaId/tarifas'
          render={({match}) => (
            <VigenciaTarifa.Index
              concessionaria={concessionaria}
              match={match}
            />
          )}>
        </Route>
        <Route
          exact path='/concessionarias/:concessionariaId/tarifas/new'
          render={({match}) => (
            <VigenciaTarifa.Form
              concessionaria={concessionaria}
              match={match}
            />
          )}
        />
        <Route
          exact path='/concessionarias/:concessionariaId/tarifas/:id/edit'
          render={({match}) => (
            <VigenciaTarifa.Form
              concessionaria={concessionaria}
              match={match}
            />
          )}
        />
        <Route
          exact path='/concessionarias/:concessionariaId/tarifas/:id'
          render={({match}) => (
            <VigenciaTarifa.Show
              concessionaria={concessionaria}
              match={match}
            />
          )}
        />
      </Switch>
    </div>
  )
}

VigenciasTarifas.propTypes = {
  concessionaria: PropTypes.object.isRequired,
}

export default VigenciasTarifas
